import React from 'react';
import { Button, Card } from 'react-bootstrap';
import '../../styles/components/UserInventory.css';
import { FEATURE_FLAGS, isFeatureEnabled } from '../../config/featureFlags';

const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '1rem',
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
};

const UserAssetList = ({ assets, onAssetCardClick, onListAssetClick = () => {} }) => {
    const barterEnabled = isFeatureEnabled(FEATURE_FLAGS.marketplaceBarter);
    if (!assets) {
        // Data is still loading
        return <div>Loading...</div>;
    }

    return (
        <section className="user-inventory-list" style={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
            <div style={gridStyle}>
                {assets.map((asset) => {
                    const isListed = Boolean(asset.isFree || (barterEnabled && asset.tradable));
                    const listingModes = [
                        asset.isFree ? 'Free' : null,
                        barterEnabled && asset.tradable ? 'Trade' : null,
                    ].filter(Boolean);

                    return (
                    <Card
                        key={asset.id}
                        onClick={() => onAssetCardClick(asset)}
                        className="user-inventory-card"
                        style={{
                            width: '100%',
                            minWidth: 0,
                            minHeight: '460px',
                            overflow: 'hidden',
                            boxSizing: 'border-box',
                        }}
                    >
                        <Card.Body className="d-flex flex-column gap-2 p-3" style={{ minWidth: 0 }}>
                            <div className="user-inventory-image-wrap" style={{ width: '100%', padding: '0.5rem', borderRadius: '0.75rem' }}>
                                <img
                                    className="user-inventory-image"
                                    src={asset.imageURL}
                                    alt="asset"
                                    style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '0.6rem' }}
                                />
                            </div>
                            <Card.Title className="user-inventory-card-title user-inventory-card-title-clamp" style={{ marginBottom: '0.25rem', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                                {asset.assetName}
                            </Card.Title>
                            <Card.Text className="mb-0 user-inventory-card-description user-inventory-card-description-clamp" style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                                {asset.assetDescription}
                            </Card.Text>
                            <div className="user-inventory-listing-strip">
                                <span className={isListed ? 'user-inventory-listing-status is-listed' : 'user-inventory-listing-status'}>
                                    {isListed ? `Listed: ${listingModes.join(' / ')}` : 'Not listed yet'}
                                </span>
                                <Button
                                    type="button"
                                    className="user-inventory-listing-button"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onListAssetClick(asset);
                                    }}
                                    aria-label={`${isListed ? 'Edit marketplace listing for' : 'List'} ${asset.assetName || 'inventory item'}`}
                                >
                                    {isListed ? 'Edit listing' : 'Give away / trade'}
                                </Button>
                            </div>
                            {asset.availability && !asset.isDeleted && <a href={`/needs?offerAssetId=${asset.id}`} onClick={(event) => event.stopPropagation()}>Offer to a Need</a>}
                        </Card.Body>
                    </Card>
                    );
                })}
            </div>
        </section>
    );
};

export default UserAssetList;
